module.exports = __webpack_public_path__ + "static/media/app-store.bbe1595f.png";